const MAX_MESSAGES = 50;
const MEMORY_KEY = "firestoreStudio.ai.conversationMemory";

function loadAll() {
  try {
    const raw = localStorage.getItem(MEMORY_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveAll(data) {
  try {
    localStorage.setItem(MEMORY_KEY, JSON.stringify(data));
  } catch { /* quota */ }
}

/**
 * Per-session conversation memory (max 50 messages) plus contextual slots.
 */
export function getConversationMemory(sessionId) {
  const all = loadAll();
  return all[sessionId] || {
    messages: [],
    context: {
      collection: null,
      connectionId: null,
      employee: null,
      branch: null,
      date: null,
      reportType: null,
      lastQuery: null,
      lastResultCount: null,
    },
  };
}

export function appendToMemory(sessionId, message, contextPatch = {}) {
  const all = loadAll();
  const mem = getConversationMemory(sessionId);
  const messages = [...mem.messages, message].slice(-MAX_MESSAGES);
  const context = { ...mem.context, ...contextPatch };
  all[sessionId] = { messages, context };
  saveAll(all);
  return all[sessionId];
}

export function updateMemoryContext(sessionId, patch) {
  const all = loadAll();
  const mem = getConversationMemory(sessionId);
  all[sessionId] = { ...mem, context: { ...mem.context, ...patch } };
  saveAll(all);
  return all[sessionId].context;
}

export function clearMemory(sessionId) {
  const all = loadAll();
  delete all[sessionId];
  saveAll(all);
}

/** Drop conversation memory entries scoped to a deleted connection. */
export function clearMemoryForConnection(connectionId) {
  if (!connectionId) return;
  const all = loadAll();
  let changed = false;
  Object.keys(all).forEach((sessionId) => {
    if (all[sessionId]?.context?.connectionId === connectionId) {
      delete all[sessionId];
      changed = true;
    }
  });
  if (changed) saveAll(all);
}

export function getRecentQuestions(sessionId, n = 10) {
  return getConversationMemory(sessionId).messages
    .filter((m) => m.role === "user")
    .slice(-n)
    .map((m) => m.content);
}
